import * as user from './user';
import * as organization from './organization';
import * as application from './application';
import * as message from './message';

export default {
  user,
  organization,
  application,
  message,
};
